import JSEncrypt from 'jsencrypt';

/**
 * RSA Encryption Utility
 * Handles RSA public key encryption using JSEncrypt library
 */
export class RSAEncryptionUtil {
  /**
   * Encrypt plaintext with RSA public key
   * @param publicKey - Base64 encoded PEM public key from server
   * @param plaintext - Text to encrypt
   * @returns Base64 encoded encrypted string
   */
  static async encrypt(publicKey: string, plaintext: string): Promise<string> {
    try {
      // Decode the base64 to get the PEM formatted key
      const pemKey = atob(publicKey);

      // Initialize JSEncrypt
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(pemKey);

      // Encrypt the plaintext
      const encrypted = encryptor.encrypt(plaintext);

      if (!encrypted) {
        throw new Error('Encryption failed');
      }

      return encrypted;
    } catch (error) {
      throw new Error(
        `Encryption failed: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`
      );
    }
  }
}
